import { createContext, useContext } from "react";
var StageContext = createContext({
    stageImage: "Stage-Bilder_PalmaDeMallorca1.jpg",
    setStageImage: function() {}
});
var useStageContext = function() {
    return useContext(StageContext);
};
export { StageContext, useStageContext };
